package com.vizio.redwolf.utils

fun String?.toStringorEmpty() = if(isNullOrEmpty()) "" else this